<mat-nav-list>
  <div class="text-center mrtb-5">
    <button
      class="logIn-btn bg-white text-primary ptb-2 border-0 pse-7 border-radius-5 size-4 weight-700 w-100 max-150 m-auto"
      mat-button
      (click)="openDialog()"
      *ngIf="!global.authenticated"
    >
      {{ "header.logIn" | translate }}
    </button>
    <a
      routerLink="account"
      class="d-flex align-items-center justify-content-center cursor-pointer"
      *ngIf="global.authenticated"
    >
      <div class="rounded-circle bg-gray2 profile-img">
        <img src="{{ global?.customer?.avatar }}" alt="img" />
      </div>
      <div class="text-primary mrs-5 size-7">
        {{ global?.customer?.firstName }}
      </div>
    </a>
  </div>

  <mat-list-item
    class="size-7 weight-600 text-primary"
    [matMenuTriggerFor]="menu"
  >
    <a matline>{{ "header.services" | translate }}</a>
    <mat-icon>unfold_more</mat-icon>
  </mat-list-item>
  <mat-menu #menu="matMenu">
    <a
      mat-menu-item
      (click)="onSidenavClose()"
      class="menu-item mrb-4"
      *ngFor="let s of global.services; let i = index"
      [routerLink]="['/service', s.serviceId]"
    >
      <img
        class="border-radius-5 small-img mre-2"
        src="{{ s.thumbnail }}"
        alt="img"
      />
      <span class="weight-600 text-primary">
        {{ s.name || s.nameAr }}
      </span>
    </a>
  </mat-menu>

  <a
    mat-list-item
    class="size-7 weight-600 text-primary"
    routerLinkActive="active"
    routerLink="/about-us"
    (click)="onSidenavClose()"
  >
    {{ "header.aboutUs" | translate }}
  </a>
  <a
    mat-list-item
    class="size-7 weight-600 text-primary"
    routerLinkActive="active"
    routerLink="/session"
    (click)="onSidenavClose()"
  >
    {{ "header.sessions" | translate }}
  </a>
  <a
    mat-list-item
    class="size-7 weight-600 text-primary"
    routerLinkActive="active"
    routerLink="/doctor"
    (click)="onSidenavClose()"
  >
    {{ "header.doctors" | translate }}
  </a>
  <!-- <a mat-list-item class="size-7 weight-600 text-primary" routerLinkActive="active" routerLink="/membership" (click)="onSidenavClose()">
    {{ 'header.memberships' | translate }}
  </a> -->
  <a
    mat-list-item
    class="size-7 weight-600 text-primary"
    routerLinkActive="active"
    routerLink="/health-education"
    (click)="onSidenavClose()"
  >
    {{ "header.blog" | translate }}
  </a>
  <!-- <a mat-list-item class="size-7 weight-600 text-primary" routerLinkActive="active" routerLink="/news" (click)="onSidenavClose()">
    {{ 'header.MediaCenter' | translate }}
  </a> -->
  <a
    mat-list-item
    class="size-7 weight-600 text-primary"
    routerLinkActive="active"
    routerLink="/contact-us"
    (click)="onSidenavClose()"
  >
    {{ "header.contactUs" | translate }}
  </a>
  <a
    mat-list-item
    class="size-7 weight-600 text-primary"
    routerLinkActive="active"
    routerLink="/cart"
    (click)="onSidenavClose()"
    *ngIf="global.authenticated"
  >
    {{ "cartTitle" | translate }}
    <span>
      <svg class="m-3" width="20" height="20" viewBox="0 0 24 24">
        <path d="M0,0H24V24H0Z" fill="rgba(0,0,0,0)" />
        <path
          d="M4,6.414.757,3.172,2.172,1.757,5.414,5H20.656a1,1,0,0,1,.958,1.287l-2.4,8a1,1,0,0,1-.958.713H6v2H17v2H5a1,1,0,0,1-1-1ZM6,7v6H17.512l1.8-6ZM5.5,23A1.5,1.5,0,1,1,7,21.5,1.5,1.5,0,0,1,5.5,23Zm12,0A1.5,1.5,0,1,1,19,21.5,1.5,1.5,0,0,1,17.5,23Z"
          fill="#10246A"
        />
      </svg>
    </span>
  </a>
  <a
    mat-list-item
    class="size-7 weight-600 text-primary"
    routerLink="/contact-us"
    (click)="onSidenavClose()"
  >
    <div
      class="cursor-pointer lang"
      *ngIf="'en' == currentLang"
      (click)="changeLang('ar')"
    >
      العربية
    </div>
    <div
      class="cursor-pointer lang"
      *ngIf="'ar' == currentLang"
      (click)="changeLang('en')"
    >
      English
    </div>
  </a>

  <div
    class="social-links d-flex align-items-center justify-content-around mrse-10 mrt-10"
  >
    <a
      class="mre-3"
      href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3709.1656468166416!2d39.12845591425592!3d21.618467972762172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3dbcebe55999b%3A0x44d901befa0cf116!2z2YXYsdmD2LIg2KfZhdin2YbYr9inINin2YTYt9io2Yo!5e0!3m2!1sen!2seg!4v1616400645619!5m2!1sen!2seg"
      ><img
        class="height-18 width-15 align-baseline"
        src="assets/images/logo-location.svg"
        alt="social icon"
    /></a>
    <a class="mre-3" href="{{ global?.setting?.linkedIn }}"
      ><img
        class="height-15 width-15 align-baseline"
        src="assets/images/logo-linkedIn.svg"
        alt="social icon"
    /></a>
    <a class="mre-3" href="{{ global?.setting?.snapchat }}"
      ><img
        class="height-15 width-15 align-baseline"
        src="assets/images/logo-snapchat.svg"
        alt="social icon"
    /></a>
    <a class="mre-3" href="{{ global?.setting?.facebook }}"
      ><img
        class="height-18 width-15 align-baseline"
        src="assets/images/logo-facebook.svg"
        alt="social icon"
    /></a>
    <a class="mre-3" href="{{ global?.setting?.twitter }}"
      ><img
        class="height-15 width-15 align-baseline"
        src="assets/images/logo-twitter.svg"
        alt="social icon"
    /></a>
    <a class="mre-3" href="{{ global?.setting?.instagram }}"
      ><img
        class="height-15 width-15 align-baseline"
        src="assets/images/logo-intgram.svg"
        alt="social icon"
    /></a>
    <!-- <a class="mre-3" href="tel:00966-920020140"><img
          class="height-15 width-15 align-baseline" src="assets/images/whatsapp-blue.svg"
          alt="social icon"></a> -->
  </div>
</mat-nav-list>
